import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Quiz.css';
import LogoutTimer from './LogoutTimer';
import useAuth from '../../hooks/useAuth.js';
import Swal from 'sweetalert2';
import adobeAnalyticsImplementationQ from './AdobeAnalyticsQ.js';
import { Button, Modal, Select } from 'antd';
import { Option } from 'antd/es/mentions/index.js';
// import aepCdpArchitectQ from './AepCdpArchitect.js';
// import aepCjaConstultantQ from './AepCjaConsultantQ.js';

const URL = process.env.REACT_APP_API_URL;

const AdobeAnalyticsTest = () => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [activeQuestion, setActiveQuestion] = useState(0);
    const [isOthersSelected, setIsOthersSelected] = useState(false);
    const [additionalSkills, setAdditionalSkills] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null);
    const [quizFinished, setQuizFinished] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(true);

    const adobe_Analytics_Skills_List = [
        { name: 'Adobe Launch', value: 'adobe_Launch' },
        { name: 'Adobe Analytics', value: 'adobe_Analytics' },
        { name: 'Google Analytics 4', value: 'google_Analytics_4' },
        { name: 'Google Tag Manager', value: 'google_Tag_Manger' },
        { name: 'Amplitude', value: 'amplitude' },
        { name: 'Piwik', value: 'piwik' },
        { name: 'Ensignten', value: 'ensignten' },
        { name: 'Tealium', value: 'tealium' },
        { name: 'Piwik PRO', value: 'piwik_Pro' },
        { name: 'Matomo', value: 'matomo' },
        { name: 'KissMetrics', value: 'kissMetrics' },
        { name: 'Plausible', value: 'plausible' }
    ]

    const [result, setResult] = useState({
        adobe_Analytics_Implementation: 0,
        correctAnswers: 0,
        wrongAnswers: 0,
        adobe_Analytics_Skills: [],
        additionalCustomSkills: []
    });

    const { questions } = adobeAnalyticsImplementationQ;
    const { question, choices, correctAnswer } = questions[activeQuestion];

    const onClickNext = () => {

        setSelectedAnswerIndex(null)
        setResult((prev) =>
            selectedAnswer
                ? {
                    ...prev,
                    adobe_Analytics_Implementation: prev.adobe_Analytics_Implementation + 1,
                    correctAnswers: prev.correctAnswers + 1,
                }
                : { ...prev, wrongAnswers: prev.wrongAnswers + 1 }
        )
        if (activeQuestion !== questions.length - 1) {
            setActiveQuestion((prev) => prev + 1)
        } else {
            setActiveQuestion(0)
            setShowResult(true)
            setQuizFinished(true)
        }
    }

    const Id = (auth._id);

    const updateAdobeAnalyticsImplementation = useCallback(() => {
        const totalQuestions = questions.length;
        const passingMark = Math.ceil(totalQuestions * 0.7); // 80% passing criteria (round up)

        const correctAnswers = result.correctAnswers;
        const status = correctAnswers >= passingMark ? 'Pass' : 'Fail';// 80% passing criteria

        const adobe_Analytics_Skills = result.adobe_Analytics_Skills;

        console.log('status: ', status);

        const updatedResult = {
            adobe_Analytics_Implementation: {
                score: correctAnswers,
                status: status,
                adobe_Analytics_Skills: adobe_Analytics_Skills,
                additionalCustomSkills: additionalSkills
            },
            // correctAnswers: correctAnswers,
            // wrongAnswers: result.wrongAnswers,
        };

        fetch(`${URL}/api/candidate/${Id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedResult),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'SUCCESS') {
                    sessionStorage.setItem('needsCandidateRefresh', 'true');
                    navigate('/candidate/candidate');
                } else {
                    console.error('Failed to update candidate record:', data.message);
                }
            })
            .catch((error) => {
                console.error('Failed to update candidate record:', error);
            });
    }, [result, questions.length, navigate, Id]);

    const onAnswerSelected = (answer, index) => {
        setSelectedAnswerIndex(index);
        if (answer === correctAnswer) {
            setSelectedAnswer(true);
        } else {
            setSelectedAnswer(false);
        }
    };

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                updateAdobeAnalyticsImplementation();
                Swal.fire({
                    title: 'As You have navigated from Assessment Page',
                    text: "Adobe Analyics Implementation Test has been Disabled",
                    icon: 'error',
                    showCloseButton: true,
                    confirmButtonColor: '#00B4D2',
                    confirmButtonText: 'Ok'
                })
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [updateAdobeAnalyticsImplementation]);

    const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

    const handleCheckboxChange = (skillValue) => {
        console.log('Hi Universe!');
        console.log('skillValue: ', skillValue);
        setResult(prev => {
            const alreadySelected = prev.adobe_Analytics_Skills.includes(skillValue);
            return {
                ...prev,
                adobe_Analytics_Skills: alreadySelected
                    ? prev.adobe_Analytics_Skills.filter(skill => skill !== skillValue) // uncheck
                    : [...prev.adobe_Analytics_Skills, skillValue] // check
            };
        });
    }


    const handleOthersSkillChange = (value) => {
        setAdditionalSkills(value);

        // Merge additional skills into adobe_Analytics_Skills
        setResult(prev => ({
            ...prev,
            adobe_Analytics_Skills: [
                ...prev.adobe_Analytics_Skills.filter(skill => !additionalSkills.includes(skill)), // remove old
                ...value
            ]
        }));
    };

    //This will cause duplicates.
    // const handleSelectChange = (value) => {
    //     setAdditionalSkills((prevData) => ([
    //         ...prevData,
    //         ...value
    //     ]));
    // };

    const handleSelectChange = (value) => {
        setAdditionalSkills(value);
    };

    return (
        <>
            <div className="quiz-container">
                <div className='heading-timer'>
                    <center><h1 style={{ fontSize: "22px" }}>Adobe Analytics Implementation Test</h1></center><br />
                    {!quizFinished && <LogoutTimer initialTimer={3600} />}
                </div>

                {!showResult ? (
                    <div>
                        <div>
                            <span className="active-question-no">
                                {addLeadingZero(activeQuestion + 1)}
                            </span>
                            <span className="total-question">
                                /{addLeadingZero(questions.length)}
                            </span>
                        </div>
                        <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>{question}</h1>
                        <ul>
                            {choices.map((answer, index) => (
                                <li
                                    onClick={() => onAnswerSelected(answer, index)}
                                    key={answer}
                                    className={
                                        selectedAnswerIndex === index ? 'selected-answer' : null
                                    }>
                                    {answer}
                                </li>
                            ))}
                        </ul>
                        <div className="flex-right">
                            <button
                                onClick={onClickNext}
                                disabled={selectedAnswerIndex === null}>
                                {activeQuestion === questions.length - 1 ? 'Finish' : 'Next'}
                            </button>
                        </div>
                    </div>
                ) :
                    (
                        <div className="click-finish">
                            <button className='redirect' onClick={updateAdobeAnalyticsImplementation}>
                                Go back To Assessment Page
                            </button>
                        </div>
                    )
                }
            </div>
            <Modal
                open={isModalVisible}
                footer={null}
                width={500}
                onCancel={() => { setIsModalVisible(false) }}
            >
                <div>
                    <h1>Select your adobe analytics skills</h1><br />
                    {/* <div style={{ display: 'flex', flexDirection: 'row', }}> */}
                    {adobe_Analytics_Skills_List.map((skill, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'row', marginTop: '8px' }}>
                            <input
                                type="checkbox"
                                value={skill.value}
                                checked={result.adobe_Analytics_Skills.includes(skill.value)}
                                onChange={() => handleCheckboxChange(skill.value)}
                                style={{ marginLeft: '-150px', marginTop: '4px' }}
                            />
                            <span style={{ marginLeft: '-150px' }}>{skill.name}</span>
                        </div>
                    ))}
                    {/* </div> */}
                    <div style={{ display: 'flex', marginTop: '8px' }}>
                        <input
                            type="checkbox"
                            value={isOthersSelected}
                            checked={isOthersSelected}
                            // onChange={() => handleCheckboxChange()}
                            onChange={(e) => setIsOthersSelected(e.target.checked)}
                            style={{ marginLeft: '-150px', marginTop: '4px' }}
                        />
                        <span style={{ marginLeft: '-150px' }}>Others</span>
                    </div>
                    {isOthersSelected &&
                        <>
                            <Select
                                mode="tags"
                                placeholder="Enter skill & press Enter Key"
                                value={additionalSkills}
                                onChange={(value) => handleSelectChange(value)}
                                style={{ width: '190px', marginBottom: '13px' }}
                                required
                            >
                                {additionalSkills.map((skill, index) => (
                                    <Option key={index} value={skill}>
                                        {skill}
                                    </Option>
                                ))}
                            </Select>
                        </>
                    }
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ backgroundColor: 'lightgreen', marginRight: '15px' }} onClick={() => setIsModalVisible(false)} disabled={result.adobe_Analytics_Skills.length === 0}>Submit</Button>
                        <Button style={{ backgroundColor: 'red' }} onClick={() => setIsModalVisible(false)} >Close</Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AdobeAnalyticsTest;
